document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuButton && mobileMenu) {
    const closeMenu = () => {
      mobileMenu.classList.remove('open');
      document.body.classList.remove('menu-open');
      menuButton.setAttribute('aria-expanded', 'false');
    };

    menuButton.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      document.body.classList.toggle('menu-open', open);
      menuButton.setAttribute('aria-expanded', String(open));
    });

    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  }

  document.querySelectorAll('[data-premium-product]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    const select = root.querySelector('[data-product-select]');
    const price = root.querySelector('[data-main-price]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const comparePrice = root.querySelector('[data-compare-price]');
    const addButtons = [root.querySelector('[data-main-add-button]'), root.querySelector('[data-sticky-submit]')].filter(Boolean);
    const quantity = root.querySelector('[data-quantity-input]');
    const stickyBar = root.querySelector('[data-sticky-atc]');
    const mainAdd = root.querySelector('[data-main-add-button]');

    const updateVariant = () => {
      if (!select) return;
      const option = select.options[select.selectedIndex];
      if (!option) return;

      if (option.dataset.price) {
        if (price) price.textContent = option.dataset.price;
        if (stickyPrice) stickyPrice.textContent = option.dataset.price;
      }

      if (comparePrice) {
        if (option.dataset.comparePrice) {
          comparePrice.textContent = option.dataset.comparePrice;
          comparePrice.classList.remove('is-hidden');
        } else {
          comparePrice.textContent = '';
          comparePrice.classList.add('is-hidden');
        }
      }

      const available = option.dataset.available === 'true';
      addButtons.forEach((button) => {
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      });
    };

    select?.addEventListener('change', updateVariant);
    updateVariant();

    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });

    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });

    root.querySelector('[data-sticky-submit]')?.addEventListener('click', () => {
      if (form) form.requestSubmit();
    });

    const modal = root.querySelector('[data-size-guide-modal]');
    const openButtons = root.querySelectorAll('[data-size-guide-open]');
    const closeButtons = root.querySelectorAll('[data-size-guide-close]');
    const openModal = () => {
      if (!modal) return;
      modal.hidden = false;
      document.body.classList.add('size-guide-open');
      modal.querySelector('[data-size-guide-close]')?.focus();
    };
    const closeModal = () => {
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove('size-guide-open');
    };

    openButtons.forEach((button) => button.addEventListener('click', openModal));
    closeButtons.forEach((button) => button.addEventListener('click', closeModal));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    if (stickyBar && mainAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      }).observe(mainAdd);
    }
  });

  document.querySelectorAll('[data-countdown-section]').forEach((section) => {
    const date = new Date(section.dataset.launchDate);
    if (Number.isNaN(date.getTime())) return;

    const fields = {
      days: section.querySelector('[data-countdown-days]'),
      hours: section.querySelector('[data-countdown-hours]'),
      minutes: section.querySelector('[data-countdown-minutes]'),
      seconds: section.querySelector('[data-countdown-seconds]')
    };

    const render = () => {
      const distance = Math.max(0, date.getTime() - Date.now());
      const values = {
        days: Math.floor(distance / 86400000),
        hours: Math.floor((distance % 86400000) / 3600000),
        minutes: Math.floor((distance % 3600000) / 60000),
        seconds: Math.floor((distance % 60000) / 1000)
      };
      Object.entries(values).forEach(([key, value]) => {
        if (fields[key]) fields[key].textContent = String(value).padStart(2, '0');
      });
    };

    render();
    window.setInterval(render, 1000);
  });
});
